import { ChannelListProviderInterface } from '@sendbird/uikit-react/ChannelList/context';

export const getCurrentChannel = (channelListState: ChannelListProviderInterface, currentChannelId: string | null) =>
  channelListState?.allChannels.find(({ url }) => url === currentChannelId);
